import React from 'react';

import { Box } from '@vp/swan';

import { FinishingOptionsWrapper, FinishingOptionsWrapperProps } from './FinishingOptionsWrapper';
import { FlyoutElement } from './FlyoutElement';
import { shouldRender as shouldRenderMailingServices } from './mailing-services';
import { MailingServicesWrapper, MailingServicesWrapperProps } from './MailingServicesWrapper';
import { shouldRender as shouldRenderFinishingOptions } from './product-finishing-options';
import {
  shouldRender as shouldRenderSampleFlyout,
  SamplesProps,
} from './product-samples/components/Samples';
import { SamplesWrapper } from './SamplesWrapper';
import { shouldRender as shouldRenderSizeDimensions } from './size-dimensions';
import { SizeDimensionsWrapper, SizeAndDimensionsWrapperProps } from './SizeDimensionsWrapper';
import { shouldRender as shouldRenderSpecsAndTemplates } from './specs-and-templates';
import {
  SpecsAndTemplatesWrapper,
  SpecsAndTemplatesWrapperProps,
} from './SpecsAndTemplatesWrapper';

export interface FlyoutContainerProps {
  sampleProps: SamplesProps;
  specsAndTemplatesProps: SpecsAndTemplatesWrapperProps;
  sizeDimensionsProps: SizeAndDimensionsWrapperProps;
  finishingOptionsProps: FinishingOptionsWrapperProps;
  mailingServicesProps: MailingServicesWrapperProps;
}

export const FlyoutContainer: React.FC<FlyoutContainerProps> = (props) => {
  const flyoutElements: Flyout[] = [
    {
      shouldRender: shouldRenderMailingServices(props.mailingServicesProps),
      element: <MailingServicesWrapper {...props.mailingServicesProps} />,
    },
    {
      shouldRender: shouldRenderSampleFlyout(props.sampleProps),
      element: <SamplesWrapper {...props.sampleProps} />,
    },
    {
      shouldRender: shouldRenderSpecsAndTemplates(props.specsAndTemplatesProps),
      element: <SpecsAndTemplatesWrapper {...props.specsAndTemplatesProps} />,
    },
    {
      shouldRender: shouldRenderFinishingOptions(props.finishingOptionsProps),
      element: <FinishingOptionsWrapper {...props.finishingOptionsProps} />,
    },
    {
      shouldRender: shouldRenderSizeDimensions(props.sizeDimensionsProps),
      element: <SizeDimensionsWrapper {...props.sizeDimensionsProps} />,
    },
  ];

  const filteredFlyoutElements = flyoutElements.filter((flyout) => flyout.shouldRender);
  return (
    shouldRenderAnyFlyout(flyoutElements) && (
      <Box>
        {filteredFlyoutElements.map((flyout, index) => (
          <FlyoutElement
            key={`flyout-${index}`}
            isLast={index === filteredFlyoutElements.length - 1}
          >
            {flyout.element}
          </FlyoutElement>
        ))}
      </Box>
    )
  );
};
const shouldRenderAnyFlyout = (flyoutElements: Flyout[]): boolean =>
  flyoutElements.some((flyout) => flyout.shouldRender);

interface Flyout {
  shouldRender: boolean;
  element: React.ReactNode;
}
